
export const GoogleAuthenticator = {
    googlePlay: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_us",
    appleStore: "https://apps.apple.com/us/app/google-authenticator/id388497605",
};